<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    title="编辑物流"
    custom-class="customModal">
    <el-form ref="form" :model="form" >
      <el-form-item label="物流公司:">
        <el-select v-model="shipping_name" style="width:100%" @change="change">
          <el-option
            v-for="item in shipData"
            :key="item.shipping_id"
            :label="item.shipping_name"
            :value="item.shipping_id">
          </el-option>
    </el-select>
      </el-form-item>
      <el-form-item label="物流单号:">
        <el-input v-model="form.shipping_sn"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { OrderService } from '../../service/order.service';
  export default {
    name: 'editdelivery',
    data() {
      return {
        visible: false,
        shipData: [],
        form:{
          shipping_name:"",
          shipping_code:"",
          shipping_sn:"",
          order_id:""
        },
        shipping_name:""
      }
    },
    created() {
      OrderService.shippList({ page: 1, rows: 99999 }).then((res)=>{
        this.shipData = res.data;
      });
    },
    methods: {
      open(data) {
        this.visible = true;
        this.form.shipping_name = data.shipping_name
        this.shipping_name = data.shipping_name
        this.form.shipping_code = data.shipping_code
        this.form.shipping_sn = data.shipping_sn
        this.form.order_id = data.order_id
      },
      change(data){
        this.form.shipping_code = data
        this.form.shipping_name = this.shipping_name
      },
      cancel() {
        this.visible = false;
      },
      submit() {
        this.shipData.find(item => {
          if(item.shipping_id === this.form.shipping_code){
            this.form.shipping_name = item.shipping_name
            return
          }
        })
        OrderService.editDelivery({...this.form}).then(()=>{
          this.cancel();
          this.$emit('success');
        })
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>